import { X } from 'lucide-react';
import { CALENDLY_DEFAULT } from '../constants/calendly';
import './TrainingMethodModal.css';

function TrainingMethodModal({ isOpen, onClose, methods, onSelectMethod, onBook }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <X size={24} />
        </button>
        
        <div className="modal-header">
          <h2 className="modal-title">Choose Your Training Method</h2>
          <p className="modal-subtitle">Select the option that best fits your lifestyle and goals</p>
        </div>
        
        <div className="training-methods-grid">
          {methods.map((method) => (
            <div key={method.id} className={`method-card ${method.featured ? 'featured' : ''}`}>
              {method.featured && <div className="featured-badge">Most Popular</div>}
              {method.imageUrl ? (
                <div className="method-card-image-wrap">
                  <img
                    src={method.imageUrl}
                    alt={method.title ? `${method.title}` : ''}
                    className="method-card-image"
                    loading="lazy"
                  />
                </div>
              ) : null}
              <h3 className="method-title">{method.title}</h3>
              <p className="method-description">{method.description}</p>
              
              {method.features && method.features.length > 0 && (
                <ul className="method-features">
                  {method.features.map((feature, index) => (
                    <li key={index}>✓ {feature}</li>
                  ))}
                </ul>
              )}
              
              <button
                type="button"
                className="method-button"
                onClick={() => {
                  const bookingUrl = method.calendlyUrl || CALENDLY_DEFAULT;
                  if (onBook) {
                    onBook(bookingUrl);
                  } else {
                    window.open(bookingUrl, '_blank', 'noopener,noreferrer');
                  }
                }}
              >
                Book {method.title} Session
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TrainingMethodModal;
